module.exports = __webpack_public_path__ + "static/media/infographie.ee515dc7.png";